import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CompanyComponent from "../components/CompanyComponent";
import CompanyContainer from "../CompanyContainer";
import equityIcon from "../../../assets/design-revamp-company/equity-component/equity-icon.svg";
import { addEquityInvestmentToBusiness } from "../../../apis/Business/EquityInvestmentApi";
import Equity from "../Equity";

const AddEquity = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const [nickname, setNickname] = useState("");
  const [investeeName, setInvesteeName] = useState("");
  const [country, setCountry] = useState("");
  const [shareEquity, setShareEquity] = useState("");
  const [ownershipStructure, setOwnershipStructure] = useState("");
  const [scope1, setScope1] = useState("");
  const [scope2, setScope2] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    if (year == null || year === "") {
      navigate("/company");
    }
  }, [navigate, year]);

  const handleFormDataChange = (updatedFormData) => {
    setInvesteeName(updatedFormData.investeeName);
    setNickname(updatedFormData.nickname);
    setCountry(updatedFormData.country);
    setShareEquity(updatedFormData.shareEquity);
    setOwnershipStructure(updatedFormData.ownershipStructure);
    setScope1(updatedFormData.scope1);
    setScope2(updatedFormData.scope2);
  };

  const save = () => {
    addEquityInvestmentToBusiness({
      nickname: nickname,
      investee_name: investeeName,
      country: country,
      share_equity: shareEquity,
      ownership_structure: ownershipStructure,
      scope_1: scope1,
      scope_2: scope2,
      setErrorMessage: setErrorMessage,
      use_swal: true,
      callback: () =>
        setTimeout(() => {
          window.location.reload();
        }, 1000),
    });
  };

  const handleSave = () => {
    save();
    return;
  };

  return (
    <CompanyContainer>
      <div
        className="companydetail"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingRight: "42px",
          marginBottom: "94.45px",
        }}
      >
        <CompanyComponent
          name={investeeName}
          address_line_1={country}
          iconComponent={equityIcon}
        />
        <Equity
          initialData={{
            nickname,
            investeeName,
            country,
            shareEquity,
            ownershipStructure,
            scope1,
            scope2,
          }}
          isNewFacility={true}
          onFormDataChange={handleFormDataChange}
          handleSave={handleSave}
          errorMessage={errorMessage}
          setCurrentName={setInvesteeName}
          setCutOffAddress={setCountry}
        />
      </div>
    </CompanyContainer>
  );
};

export default AddEquity;
